<template>
  <div class="profile wrapper" v-if="card">
    <div class="shape content uk-background-cover text-white-shadow"
         :style="{'background-image': 'url(' + card.image_url +')'}">
      <!-- カードラベル 一覧表示の場合 -->
      <div v-show="thumbnail">
        <div class="name-plate uk-text-center" style="margin-top: 6%">
          <div class="uk-visible@s">
            <div class="text-en text-middle">{{card.en}}</div>
            <div class="text-ja text-small" style="margin-top: 2px">
              {{card.ja}}
              <div style="margin-top: 2px">{{card.qty}} 枚</div>
            </div>
          </div>
          <!-- スマホで文字を枠内に収める対応 FIXME 整理する -->
          <div class="uk-hidden@s" style="font-size: 0.8em">
            <div class="text-en text-middle" style="line-height: 1.2em">{{card.en}}</div>
            <div class="text-ja text-small" style="margin-top: 3px; line-height: 1.2em">
              {{card.ja}}
              <div style="margin-top: 3px">{{card.qty}} 枚</div>
            </div>
          </div>
        </div>
      </div>
      <!-- カードラベル 拡大表示の場合 -->
      <div v-show="!thumbnail">
        <div class="name-plate uk-text-center" style="margin-top: 7%">
          <div class="text-en text-large">{{card.en}}</div>
          <div class="text-ja text-middle" style="margin-top: 8px">
            {{card.ja}}
          </div>
        </div>
      </div>
      <!-- カードセット表示 -->
      <div v-show="card.game == 'CAA'" class="caa-plate uk-background-cover"
           :style="{'background-image': 'url(' + caa_image_url +')'}">
        <div class="text-en text-small">
          CAA
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Profile',
    data() {
      return {
        caa_image_url: require("../assets/media/its-caa-thumb.jpg")
      }
    },
    props: {
      card: Object, // カード情報
      thumbnail: Boolean // サムネイル表示（表示文字サイズに関係）
    }
  }
</script>

<style scoped>
  /*アスペクト比固定用*/
  .wrapper {
    position: relative;
    width: 100%;
  }

  /*アスペクト比固定用*/
  .wrapper:before {
    content: "";
    display: block;
    padding-top: 154%; /* 高さを幅のX%に固定 */
  }

  /*アスペクト比固定用*/
  .content {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
  }

  /* カードの形、枠線 */
  .shape {
    border-radius: 5% / 3.25%;
    border: 1px solid #333;
    box-shadow: 2px 2px 6px 2px rgba(0, 0, 0, 0.3);
  }

  /* カード名表示 */
  .name-plate {
    /*border: solid 1px red;*/
    margin-left: 14%;
    margin-right: 9%;
    word-wrap: break-word;
  }

  .text-white-shadow {
    color: white;
    /* 文字の影 ぼかしのみを重ねがけして自然な縁取り */
    text-shadow: 0px 0px 3px rgba(0, 0, 0, 1),
    0px 0px 3px rgba(0, 0, 0, 1),
    0px 0px 3px rgba(0, 0, 0, 1),
    0px 0px 3px rgba(0, 0, 0, 1),
    0px 0px 3px rgba(0, 0, 0, 1),
    0px 0px 3px rgba(0, 0, 0, 1);
  }

  .text-large {
    font-size: 1.2em;
    line-height: 1.1em;
  }

  .text-middle {
    font-size: 1em;
    line-height: 1.1em;
  }

  .text-small {
    font-size: 0.85em;
    line-height: 1.1em;
  }

  /* 英字フォント */
  .text-en {
    font-family: 'Oswald', Arial, "Hiragino Kaku Gothic ProN", Meiryo, sans-serif;
    transform: scale(0.9, 1);
  }

  /* 日本語フォント */
  .text-ja {
    font-family: 'Noto Sans JP', Arial, "Hiragino Kaku Gothic ProN", Meiryo, sans-serif;
    transform: scale(0.95, 1);
  }

  /* 拡張表示 */
  .caa-plate {
    position: absolute;
    width: 30%;
    height: 10%;
    top: 60%;
    right: 0;
    border-right: none;
    border-top: white solid 2px;
    border-bottom: white solid 2px;
    border-left: white solid 2px;
    border-radius: 5px 0 0 5px;
    text-align: center;
    color: white;
    display: table;
  }

  /* 上下中央寄せ */
  .caa-plate div {
    display: table-cell;
    vertical-align: middle;
  }
</style>
